import React, { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    // Skip scroll if this navigation was a language switch (state.langSwitch === true)
    const w = typeof window !== "undefined" ? window : null;
    const skip = w && w.history && w.history.state && w.history.state.usr && w.history.state.usr.langSwitch;
    if (skip) return;
    // Also skip if pathname changes are only hash based
    if (navType !== "POP") {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
    }
  }, [pathname, navType]);

  return null;
}
